module.exports = __webpack_public_path__ + "img/bgr-confetti-yellow.83c6ef9b.svg";